import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Resultimpact() {
  return (
    <section className="result_impact_milo p-100 text_milo">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Results and <span>Impact</span>
            </h2>
            <p>
              MiloCare+ has suggestively improved user access and ease in
              managing health records, particularly Covid test results and
              vaccination data. Users can swiftly retrieve and share their
              health information, leading to improved record-keeping for
              families. The app's stringent data security measures have not only
              introduced user trust but have also guaranteed complete obedience
              with industry values and principles.
            </p>
            <p>
              MiloCare+ has appeared as a dependable and secure platform for
              health record management, positively influencing the healthcare
              experience for individuals and their loved ones.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img">
              <StaticImage
                src="../../../images/case-studies/milocare/result.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={692}
                height={608}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultimpact;
